export const API_URLS_LIST = {
  BASE_URL: '/',
  // BASE_URL: 'http://localhost:8080/',

  LOGIN: 'care360/public/api/user/login',
  updatePasswordOkta: 'care360/public/api/user/updatePasswordOkta', // new Okta api for changing password from public
  authorize: 'care360/secure/api/user/authorize',
  refreshToken: 'care360/secure/api/user/refreshToken',
  FORGOTUSERNAME: 'care360/public/api/user/forgotUsernameOkta', //Okta
  FORGOTACCESSCODE: 'care360/public/api/user/forgotAccessCodeOkta', //Okta
  GETEXPERIENCERULES: 'care360/secure/api/user/getExperienceRules',
  getCCEs: 'care360/secure/api/user/cceNames',
  memberListing: 'care360/secure/api/member/getMemberRoster',
  getCCEEvents: 'care360/secure/api/user/getCCEEvents',
  getContent: 'care360/public/api/user/getContent',
  searchMember: 'care360/secure/api/member/searchMember',
  getMemberById: 'care360/secure/api/member/getMemberById',
  addMembertoHip: 'care360/secure/api/member/addMembertoHip',
  getAnthemCareTeams: 'care360/secure/api/member/getAnthemCareTeams',
  getToolsResources: 'care360/secure/api/user/getToolsResources',
  getCIIDashboard: 'care360/secure/api/user/getCIIDashboard',
  changeAccessCode: 'care360/public/api/user/changeAccessCodeOkta', //Okta
  getCCEUsers: 'care360/secure/api/user/getCCEUsers',
  getMemberFileList: 'care360/secure/api/member/getMemberFileList',
  getClaimsListing: 'care360/secure/api/member/getClaimsListing', 
  getClaimDetails: 'care360/secure/api/member/getClaimDetails', 
  getHealthTrends: 'care360/secure/api/member/healthTrends', 
  getAlertsById: 'care360/secure/api/member/getAlertsById',
  getMemberProgramsAndWaivers:
    'care360/secure/api/member/getMemberProgramsAndWaivers',
  getMemberConsent: 'care360/secure/api/member/getMemberConsent',
  getWellnessBenefitsById: 'care360/secure/api/member/getWellnessBenefitsById',
  getSocialDeterminantInfo:
    'care360/secure/api/member/getSocialDeterminantInfo',
  getOpportunities: 'care360/secure/api/member/getOpportunities',
  getMemberPCPDetails: 'care360/secure/api/member/getMemberPCPDetails',
  getCareGaps: 'care360/secure/api/member/getCareGaps',
  updateMember: 'care360/secure/api/member/updateMember',
  getMemberAssessments:
    'care360/secure/api/member/getMemberAssessments', 
    getMemberViewAssessment:
    'care360/secure/api/member/getMemberViewAssessment',  
  getDocumentsById: 'care360/secure/api/member/getDocumentsById', 
  getDocumentByDocId: 'care360/secure/api/member/getDocumentByDocId', 
  saveMemberDoc: 'care360/secure/api/member/saveMemberDoc',
  getImmunizations: 'care360/secure/api/member/getImmunizations',
  getImmunizationHistory: 'care360/secure/api/member/getImmunizationHistory',
  getStaticCodeValue: 'care360/secure/api/member/getStaticCodeValue',
  addImmunization: 'care360/secure/api/member/addImmunization',
  getTestEvaluationHistory:
    'care360/secure/api/member/getTestEvaluationHistory',
     getMemberAttribution: 'care360/secure/api/member/getMemberAttribution',
     addMember: 'care360/secure/api/member/saveMemberAttribution',
  addTestEvaluation: 'care360/secure/api/member/addTestEvaluation',
  getMemberAllergies: 'care360/secure/api/member/getMemberAllergies',
  addorUpdateAllergies: 'care360/secure/api/member/addorUpdateAllergies',
  getAdvancedirective: 'care360/secure/api/member/getAdvancedirective',
  addorUpdateAdvDirective: 'care360/secure/api/member/addorUpdateAdvDirective',
  getCareTeamDetails: 'care360/secure/api/member/getCareTeamDetails', 
  getCarePlanGoals: 'care360/secure/api/member/getCarePlanGoals', 
  getCarePlanGoalDetails:
    'care360/secure/api/member/getCarePlanGoalDetails', 
  getUtilizationDetails:
    'care360/secure/api/member/getUtilizationDetails',
  createAttestation: 'care360/secure/api/user/createAttestation',
  searchGNACases: 'care360/secure/api/member/searchGNACases',
  getGNACaseDetails: 'care360/secure/api/member/getGNACaseDetails',
  getConditions: 'care360/secure/api/member/getConditions',
  postConditions: 'care360/secure/api/member/conditions',
  getConditionsHistory: 'care360/secure/api/member/conditions/history',
  getCriticalIncidentDetails : 'care360/secure/api/member/getCriticalIncidentDetails',
  getCareActions: 'care360/secure/api/member/getCareActions',
  addActionItems: 'care360/secure/api/user/addActionItems',
  addCareAction: 'care360/secure/api/member/addCareAction',
  updateCareAction: 'care360/secure/api/member/updateCareAction',
  getMemberCareNotes: 'care360/secure/api/member/getMemberCareNotes',
  saveMemberCareNote: 'care360/secure/api/member/saveMemberCareNote',
  saveGoodToKnow: 'care360/secure/api/member/saveGoodToKnow',
  getIdCards: 'care360/secure/api/member/getIdCards',
  emailIdCards: 'care360/secure/api/member/emailIdCards',
  faxIdCards: 'care360/secure/api/member/faxIdCards',
  mailIdCards: 'care360/secure/api/member/mailIdCards',
  getMedicationHistory: 'care360/secure/api/member/medication/history',
  postMedications: 'care360/secure/api/member/addmedications',
  getMedications: 'care360/secure/api/member/medications',
  getMedicationStaticCodes:
    'care360/secure/api/member/getMedicationStaticCodes',
  getOverutilization:
    'care360/secure/api/member/medication/overutilization',
  getDrugInteractionsLatest:
    'care360/secure/api/member/medication/interactions/latest',
  getDrugs: 'care360/secure/api/member/drugs',
  getGoodToKnowContent: 'care360/secure/api/member/getGoodToKnow',
  saveGoodToKnowContent: 'care360/secure/api/member/saveGoodToKnow',
  deleteGoodToKnowContent: 'care360/secure/api/member/deleteGoodToKnow',
  getContactHistoryRecords: 'care360/secure/api/member/getContactHistoryByMemberid',
  getContactMailFaxRecords: 'care360/secure/api/member/getContactMailFaxRecords',
  getEmailSmsChatHistoryRecords:
    'care360/secure/api/member/getEmailSmsChatHistoryRecords',
  getSmsChatConversationDetails:
    'care360/secure/api/member/getSmsChatConversationDetails',
  searchUser: 'care360/secure/api/user/searchUser',
  searchUserOkta: 'care360/secure/api/user/searchUserOkta',
  manageInternalAdmins : 'care360/secure/api/user/manageInternalAdmins',
  searchUserForSelfReg: 'care360/public/api/user/searchUser',
  checkUserExistsInOkta: 'care360/public/api/user/checkUserExistsInOkta', //public search user okta
  addUser: 'care360/secure/api/user/addUser', //Okta IAM will invoke
  addUserSelfRegistration: 'care360/public/api/user/addUserSelfRegistration',
  saveExperienceRules: 'care360/secure/api/user/saveExperienceRules',
  updateUser: 'care360/secure/api/user/updateUser',
  updateMemberFile: 'care360/secure/api/member/updateMemberFile',
  logout: 'care360/secure/api/user/logout',
  sendOTP: 'care360/public/api/user/sendOTP',
  sendOTPOkta: 'care360/public/api/user/sendOTPOkta', //Okta
  validateOTP: 'care360/public/api/user/validateOTP',
  validateOTPOkta: 'care360/public/api/user/validateOTPOkta', //Okta
  validatePasswordExpiryLink: 'care360/public/api/user/validatePasswordExpiryLink',
  loginThreat: 'care360/public/api/user/loginThreat',
  loadGCPData: 'care360/secure/api/member/loadGCPData',
  updateUserDetails: 'care360/secure/api/user/uploadUsersFromFile',
  getQuestionnaire:'care360/secure/api/member/getQuestionnaire',
  saveQuestionnaire:'care360/secure/api/member/saveQuestionnaire',
  getQuestionnaireResponse: 'care360/secure/api/member/getQuestionnaireResponse',
  saveSurveyQuestions: 'care360/secure/api/user/saveSurveyQuestions',
  getSurveyQuestions: 'care360/secure/api/user/getSurveyQuestions',
  getSurveyList: 'care360/secure/api/user/getSurveyListing',
  deleteAssessment: 'care360/secure/api/member/deleteAssessment',
  saveSurvey: 'care360/secure/api/user/saveSurvey',
  putMemberAssessments: 'care360/secure/api/member/putMemberAssessments',
  lookupMemberById: 'care360/secure/api/member/lookupMemberById',
  lookupMemberByIdSelfReg: 'care360/public/api/member/lookupMemberByIdSelfReg',
  lookupMemberByIdAdoptiveParentSelfReg: 'care360/public/api/member/lookupMemberByIdAdoptiveParentSelfReg',
  lookupMemberByIdForEnrollment: 'care360/secure/api/user/lookupMemberByIdForEnrollment',
  getCareGiverMembers: 'care360/secure/api/member/getCareGiverMembers',
  getQuestionnaireList: 'care360/secure/api/member/getQuestionnaireList',
  updatePcpDetails:'care360/secure/api/member/updatePcp',
  getTermReasonList:'care360/secure/api/member/getTermReasonList',
  getProviders:'care360/secure/api/member/getProviders',
  saveAppealGrievance : '/care360/secure/api/member/saveAppealGrievance',
  uploadAppealGrievanceDoc: '/care360/secure/api/member/uploadAppealGrievanceDoc',
  enrollMember : '/care360/secure/api/member/enrollMember',
  addMemberCommunication: 'care360/secure/api/member/addMemberCommunication',
  getEncryptedHcid: 'care360/secure/api/member/encrypt',
   pharmacyAllPrescriptions : '/care360/secure/api/member/pharmacyAllPrescriptions',
  archivePrescriptions : '/care360/secure/api/member/archivePrescriptions',
  unArchivePrescriptions : '/care360/secure/api/member/unarchivePrescriptions',
  getArchivedPrescriptions : '/care360/secure/api/member/getArchivedPrescriptions',
  deleteDeliveryAddress : '/care360/secure/api/member/pharmacy/deleteDeliveryAddress',
  addDeliveryAddress : '/care360/secure/api/member/pharmacy/addDeliveryAddress',
  updateDeliveryAddress : '/care360/secure/api/member/pharmacy/updateDeliveryAddress',
  getPharmacyOutstandingBalance : '/care360/secure/api/member/pharmacy/getOutstandingBalance',
  validateAddress : '/care360/secure/api/member/pharmacy/validateAddress',
  pharmacyAllOrders : '/care360/secure/api/member/pharmacyAllOrders',
  pharmacyAddresses : '/care360/secure/api/member/pharmacyAddresses',
  pharmacyContactDetails : '/care360/secure/api/member/pharmacyContactDetails',
  getOrderDetails : '/care360/secure/api/member/getOrderDetails',
  getPaymentDetails : '/care360/secure/api/member/getPaymentDetails',
  getPharmacyContactDetails : '/care360/secure/api/member/getContactDetails',
  updatePharmacyContactDetails : '/care360/secure/api/member/updateContactDetails',
  getPharmacyShippingOptions : '/care360/secure/api/member/pharmacy/shippingOptions',
  getCommunicationPreferences: '/care360/secure/api/member/pharmacy/getCommunicationPreferences',
  saveCommunicationPreferences: '/care360/secure/api/member/pharmacy/saveCommunicationPreferences',
  getPharmacyAllergies: '/care360/secure/api/member/pharmacy/allergies',
  getPharmacyDefaultAllergies: '/care360/secure/api/member/pharmacy/getAllergyList',
  getAllergiesByName: '/care360/secure/api/member/pharmacy/searchAllergies',
  getRefillsHistory: '/care360/secure/api/member/pharmacy/getRefillsHistory',
  updatePharmacyAllergies: '/care360/secure/api/member/pharmacy/updateAllergies',
  getSpecialtyQuestionnaire: '/care360/secure/api/member/pharmacy/getSpecialtyQuestionnaire',
  submitRefillRenew: '/care360/secure/api/member/pharmacy/submitRefillRenew',
  getPaymentMethod: '/care360/secure/api/member/pharmacy/getPaymentMethod',
  deletePaymentMethod: '/care360/secure/api/member/pharmacy/deletePaymentMethod',
  addUpdatePaymentMethod: '/care360/secure/api/member/pharmacy/addUpdatePaymentMethod',
  submitRRTForm: '/care360/secure/api/member/submitRRTForm',
  getRxMemberEligibility: '/care360/secure/api/member/pharmacy/getRxMemberEligibility',
  submitQuestionnaireAnswerResponse: '/care360/secure/api/member/pharmacy/submitQuestionnaireAnswerResponse', 
  addressHistory: '/care360/secure/api/member/addressHistory',
  getLtssProgramDetails: 'care360/secure/api/member/getLtssProgramDetails',
  saveChildDetailsForMbrAttribution: '/care360/public/api/member/saveChildDetailsForMbrAttribution',
  saveAdoptiveParentRegistration: 'care360/public/api/user/saveAdoptiveParentRegistration',
  saveInternalUsersRoles: 'care360/secure/api/user/saveInternalUsersRoles',

};
 